import { atomWithReset } from 'jotai/utils';
import { getItem, setItem } from './storage';

export function truncateString(value, length) {
  if (!value) return '';
  if (value.length <= length) return value;
  return `${value.substring(0, length - 1)}...`;
}

export function getImageDimensions(url) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = (event) => {
      const { width, height } = event.currentTarget;
      resolve({ width, height });
    };
    image.onerror = (error) => reject(error);
    image.src = url;
  });
}

export function atomWithPersist(store, prefix, key, value) {
  const storageKey = `${prefix}.${key}`;
  const newAtom = atomWithReset(value);
  const persistedValue = getItem(storageKey);

  if (persistedValue !== null) store.set(newAtom, persistedValue);
  store.sub(newAtom, () => setItem(storageKey, store.get(newAtom)));

  return newAtom;
}

export function ordinal(value) {
  const remainder = Number(value) % 100;
  const suffix = ['th', 'st', 'nd', 'rd'];
  return value + (suffix[(remainder - 20) % 10] || suffix[remainder] || suffix[0]);
}
